(function ($) {
    "use strict";

    $(document).ready(function () {

        window.onscroll = function () {
            stickyHeader()
        };

        var header = document.getElementById("mainHeader");
        var sticky = header.offsetTop;

        function stickyHeader() {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }
        }

        // Go to top button
        const toTop = document.querySelector('.to-top');
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 100) {
                toTop.classList.add("active");
            } else {
                toTop.classList.remove("active");
            }
        })

        // Offset for link anchor
        $('a[href^="#"]').not('a[href="#"]').on('click', function (e) {
            if (this.hash !== '') {
                e.preventDefault();

                var hash = this.hash;

                // var headerHeight = 124;
                var headerHeight = $('.main-menu-area').outerHeight();
                console.log(headerHeight + 'px');

                var offset = $(this).data('offset') || headerHeight;

                var isSticky = $('.sticky').length > 0;

                if (!isSticky) {
                    offset += headerHeight;
                }

                $('html, body').animate({
                    scrollTop: $(hash).offset().top - offset
                }, 800);
            }
        });

        var bodyOvrelay = $('#body-overlay');
        var searchPopup = $('#td-search-popup');

        $(document).on('click', '#body-overlay', function (e) {
            e.preventDefault();
            bodyOvrelay.removeClass('active');
            searchPopup.removeClass('active');
        });

        $(".popup-link").magnificPopup({
            type: 'image',
            fixedContentPos: false
        });

        $('.gallery').each(function () {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    tCounter: '%curr% / %total%'
                }
            });
        });

        if ($('.slider-partner-logos').length) {
            $('.slider-partner-logos').slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }]
            });
        }

        if ($('.testimonial-slider').length) {
            $('.testimonial-slider').slick({
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                rtl: false,
                vertical: true,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        }

        // Counter
        if ($('.counter').length) {
            $('.counter').counterUp({
                delay: 10,
                time: 1000
            });
        }

        // AOS
        AOS.init({
            offset: 300,
            duration: 1000,
            disable: function () {
                var maxWidth = 768;
                return window.innerWidth <= maxWidth;
            }
        });

        if ($('.testimonial-slider-for-2').length) {
            $('.testimonial-slider-for-2').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                fade: false,
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 2000,
                asNavFor: '.testimonial-slider-nav-2'
            });
        }

        if ($('.testimonial-slider-nav-2').length) {
            $('.testimonial-slider-nav-2').slick({
                slidesToShow: 'auto',
                slidesToScroll: 1,
                speed: 1000,
                centerMode: true,
                centerPadding: 0,
                asNavFor: '.testimonial-slider-for-2',
                dots: false,
                arrows: false,
                focusOnSelect: true,
            });
        }

        if ($('a[data-slide]').length) {
            $('a[data-slide]').click(function (e) {
                e.preventDefault();
                var slideno = $(this).data('slide');
                $('.testimonial-slider-nav-2').slick('slickGoTo', slideno - 1);
            });
        }

        // Mobile menu
        $('.canvas-open').on('click', function () {
            $('.offcanvas-menu-wrapper,.off-canvars-overlay').addClass('active')
        });
        $('.canvas-close,.off-canvars-overlay').on('click', function () {
            $('.offcanvas-menu-wrapper,.off-canvars-overlay').removeClass('active')
        });
        $('.has-children').on('click', function () {
            $('.has-sub-menu').addClass('active1')
        });
        $('.has-children').on('click', function () {
            $('.has-sub-menu').removeClass('active1')
        });
        var $offcanvasNav = $('.offcanvas-main-menu'),
            $offcanvasNavSubMenu = $offcanvasNav.find('.sub-menu');
        $offcanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i class="fal fa-angle-down"></i></span>');
        $offcanvasNavSubMenu.slideUp();
        $offcanvasNav.on('click', 'li a, li .menu-expand', function (e) {
            var $this = $(this);
            if (($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
                e.preventDefault();
                if ($this.siblings('ul:visible').length) {
                    $this.siblings('ul').slideUp('slow');
                } else {
                    $this.closest('li').siblings('li').find('ul:visible').slideUp('slow');
                    $this.siblings('ul').slideDown('slow');
                }
            }
            if ($this.is('a') || $this.is('span') || $this.attr('clas').match(/\b(menu-expand)\b/)) {
                $this.parent().toggleClass('menu-open');
            } else if ($this.is('li') && $this.attr('class').match(/\b('menu-item-has-children')\b/)) {
                $this.toggleClass('menu-open');
            }
        });
    });

    // particles
    $(window).on('load', function () {
        if ($('.b-hero-slider__fire').length) {
            particlesJS("b-hero-slider-fire", {
                "particles": {
                    "number": {
                        "value": 400,
                        "density": {
                            "enable": true,
                            "value_area": 3000
                        }
                    },
                    "color": {
                        "value": "#fc0000"
                    },
                    "shape": {
                        "type": "circle",
                        "stroke": {
                            "width": 0,
                            "color": "#000000"
                        },
                        "polygon": {
                            "nb_sides": 3
                        },
                        "image": {
                            "src": "img/github.svg",
                            "width": 100,
                            "height": 100
                        }
                    },
                    "opacity": {
                        "value": 0.5,
                        "random": true,
                        "anim": {
                            "enable": false,
                            "speed": 1,
                            "opacity_min": 0.1,
                            "sync": false
                        }
                    },
                    "size": {
                        "value": 2,
                        "random": true,
                        "anim": {
                            "enable": true,
                            "speed": 5,
                            "size_min": 0,
                            "sync": false
                        }
                    },
                    "line_linked": {
                        "enable": false,
                        "distance": 500,
                        "color": "#ffffff",
                        "opacity": 0.4,
                        "width": 2
                    },
                    "move": {
                        "enable": true,
                        "speed": 7.8914764163227265,
                        "direction": "top",
                        "random": true,
                        "straight": false,
                        "out_mode": "out",
                        "bounce": false,
                        "attract": {
                            "enable": false,
                            "rotateX": 600,
                            "rotateY": 1200
                        }
                    }
                },
                "interactivity": {
                    "detect_on": "canvas",
                    "events": {
                        "onhover": {
                            "enable": false,
                            "mode": "bubble"
                        },
                        "onclick": {
                            "enable": false,
                            "mode": "repulse"
                        },
                        "resize": true
                    },
                    "modes": {
                        "grab": {
                            "distance": 400,
                            "line_linked": {
                                "opacity": 0.5
                            }
                        },
                        "bubble": {
                            "distance": 400,
                            "size": 4,
                            "duration": 0.3,
                            "opacity": 1,
                            "speed": 3
                        },
                        "repulse": {
                            "distance": 200,
                            "duration": 0.4
                        },
                        "push": {
                            "particles_nb": 4
                        },
                        "remove": {
                            "particles_nb": 2
                        }
                    }
                },
                "retina_detect": true
            });
        }

        if ($('.l-breadcrumbs__fire').length) {
            particlesJS("l-breadcrumbs-fire", {
                "particles": {
                    "number": {
                        "value": 400,
                        "density": {
                            "enable": true,
                            "value_area": 3000
                        }
                    },
                    "color": {
                        "value": "#fc0000"
                    },
                    "shape": {
                        "type": "circle",
                        "stroke": {
                            "width": 0,
                            "color": "#000000"
                        },
                        "polygon": {
                            "nb_sides": 3
                        },
                        "image": {
                            "src": "img/github.svg",
                            "width": 100,
                            "height": 100
                        }
                    },
                    "opacity": {
                        "value": 0.5,
                        "random": true,
                        "anim": {
                            "enable": false,
                            "speed": 1,
                            "opacity_min": 0.1,
                            "sync": false
                        }
                    },
                    "size": {
                        "value": 2,
                        "random": true,
                        "anim": {
                            "enable": true,
                            "speed": 5,
                            "size_min": 0,
                            "sync": false
                        }
                    },
                    "line_linked": {
                        "enable": false,
                        "distance": 500,
                        "color": "#ffffff",
                        "opacity": 0.4,
                        "width": 2
                    },
                    "move": {
                        "enable": true,
                        "speed": 7.8914764163227265,
                        "direction": "top",
                        "random": true,
                        "straight": false,
                        "out_mode": "out",
                        "bounce": false,
                        "attract": {
                            "enable": false,
                            "rotateX": 600,
                            "rotateY": 1200
                        }
                    }
                },
                "interactivity": {
                    "detect_on": "canvas",
                    "events": {
                        "onhover": {
                            "enable": false,
                            "mode": "bubble"
                        },
                        "onclick": {
                            "enable": false,
                            "mode": "repulse"
                        },
                        "resize": true
                    },
                    "modes": {
                        "grab": {
                            "distance": 400,
                            "line_linked": {
                                "opacity": 0.5
                            }
                        },
                        "bubble": {
                            "distance": 400,
                            "size": 4,
                            "duration": 0.3,
                            "opacity": 1,
                            "speed": 3
                        },
                        "repulse": {
                            "distance": 200,
                            "duration": 0.4
                        },
                        "push": {
                            "particles_nb": 4
                        },
                        "remove": {
                            "particles_nb": 2
                        }
                    }
                },
                "retina_detect": true
            });
        }
    });

    /* $(window).on('load', function() {
        $('#preloader').delay(300).fadeOut(500);
    }); */

    if ($('.text-type').length) {
        new TypeIt(".text-type", {
            speed: 50,
            loop: false,
            // strings: ['Najwyższa jakość ochrony przeciwpożarowej'],
            breakLines: false,
            waitUntilVisible: true,
        }).go();
    }

})(jQuery); // end jQuery